(function () {
  'use strict';

  var moneyFormat = window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'USD';

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: moneyFormat }).format(value);
    } catch (e) {
      return '$' + value;
    }
  }

  /* ---------------------------------------------------------------------
     Mobile nav + search toggle
  --------------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var menuToggle = e.target.closest('[data-menu-toggle]');
    if (menuToggle) {
      var mobileNav = document.querySelector('[data-mobile-nav]');
      var expanded = menuToggle.getAttribute('aria-expanded') === 'true';
      menuToggle.setAttribute('aria-expanded', String(!expanded));
      if (mobileNav) {
        if (expanded) {
          mobileNav.setAttribute('hidden', '');
          mobileNav.removeAttribute('data-open');
        } else {
          mobileNav.removeAttribute('hidden');
          mobileNav.setAttribute('data-open', '');
        }
      }
    }

    var searchToggle = e.target.closest('[data-search-toggle]');
    if (searchToggle) {
      var panel = document.querySelector('[data-search-panel]');
      if (panel) {
        if (panel.hasAttribute('hidden')) {
          panel.removeAttribute('hidden');
          var input = panel.querySelector('input[type="search"]');
          if (input) input.focus();
        } else {
          panel.setAttribute('hidden', '');
        }
      }
    }
  });

  /* ---------------------------------------------------------------------
     Modals (feature grid)
  --------------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-modal-open]');
    if (opener) {
      var modal = document.getElementById(opener.getAttribute('data-modal-open'));
      if (modal) modal.removeAttribute('hidden');
    }
    var closer = e.target.closest('[data-modal-close]');
    if (closer) {
      var m = closer.closest('[data-modal]');
      if (m) m.setAttribute('hidden', '');
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('[data-modal]:not([hidden])').forEach(function (m) { m.setAttribute('hidden', ''); });
    }
  });

  /* ---------------------------------------------------------------------
     Testimonials carousel
  --------------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var prev = e.target.closest('[data-carousel-prev]');
    var next = e.target.closest('[data-carousel-next]');
    if (prev || next) {
      var track = (prev || next).closest('section').querySelector('[data-carousel]');
      if (track) {
        var card = track.querySelector('.testimonials__card');
        var amount = card ? card.getBoundingClientRect().width + 20 : 300;
        track.scrollBy({ left: next ? amount : -amount, behavior: 'smooth' });
      }
    }
  });

  /* ---------------------------------------------------------------------
     Stats counter animation
  --------------------------------------------------------------------- */
  var counters = document.querySelectorAll('[data-counter]');
  if (counters.length && 'IntersectionObserver' in window) {
    var counterObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var target = parseFloat(el.getAttribute('data-target')) || 0;
        var suffix = el.textContent.replace(/[0-9.]/g, '');
        var start = 0;
        var duration = 1200;
        var startTime = null;
        function step(ts) {
          if (!startTime) startTime = ts;
          var progress = Math.min((ts - startTime) / duration, 1);
          var value = Math.floor(progress * target);
          el.textContent = value + suffix;
          if (progress < 1) requestAnimationFrame(step);
          else el.textContent = target + suffix;
        }
        requestAnimationFrame(step);
        counterObserver.unobserve(el);
      });
    }, { threshold: 0.4 });
    counters.forEach(function (el) { counterObserver.observe(el); });
  }

  /* ---------------------------------------------------------------------
     Product gallery thumbnails
  --------------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-gallery-thumb]');
    if (thumb) {
      e.preventDefault();
      // Find the nearest gallery wrap — support both old (.main-product__gallery) and new (.pdp__gallery) markup.
      var wrap = thumb.closest('.pdp__gallery, .main-product__gallery') || thumb.parentElement.parentElement;
      var mainImg = (wrap && wrap.querySelector('[data-gallery-main] img')) || document.querySelector('[data-gallery-main] img');
      var full = thumb.getAttribute('data-full');
      if (mainImg && full) mainImg.src = full;
      (wrap || document).querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    }
  });

  /* ---------------------------------------------------------------------
     Product gallery swipe (mobile)
  --------------------------------------------------------------------- */
  (function initGallerySwipe() {
    document.querySelectorAll('[data-gallery-main]').forEach(function (main) {
      var startX = 0, startY = 0, tracking = false;
      main.addEventListener('touchstart', function (e) {
        if (!e.touches || e.touches.length !== 1) { tracking = false; return; }
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        tracking = true;
      }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (!tracking) return;
        tracking = false;
        var t = (e.changedTouches && e.changedTouches[0]) || null;
        if (!t) return;
        var dx = t.clientX - startX;
        var dy = t.clientY - startY;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
        var wrap = main.closest('.pdp__gallery, .main-product__gallery') || document;
        var thumbs = Array.prototype.slice.call(wrap.querySelectorAll('[data-gallery-thumb]'));
        if (thumbs.length < 2) return;
        var activeIdx = thumbs.findIndex(function (th) { return th.classList.contains('is-active'); });
        if (activeIdx < 0) activeIdx = 0;
        var nextIdx = dx < 0 ? (activeIdx + 1) % thumbs.length : (activeIdx - 1 + thumbs.length) % thumbs.length;
        var next = thumbs[nextIdx];
        if (next) next.click();
      }, { passive: true });
    });
  })();

  /* ---------------------------------------------------------------------
     Buy box: quantity steppers + variant option selection
  --------------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var dec = e.target.closest('[data-qty-decrease]');
    var inc = e.target.closest('[data-qty-increase]');
    if (dec || inc) {
      var stepper = (dec || inc).closest('.buy-box__qty-stepper, .cart-drawer__line-qty');
      var input = stepper.querySelector('input, [data-qty-value]');
      if (input && input.tagName === 'INPUT') {
        var val = parseInt(input.value, 10) || 1;
        val = dec ? Math.max(1, val - 1) : val + 1;
        input.value = val;
      } else if (input) {
        var line = (dec || inc).closest('[data-cart-line-key]');
        if (line) {
          var current = parseInt(input.textContent, 10) || 1;
          var next = dec ? Math.max(0, current - 1) : current + 1;
          updateCartLine(line.getAttribute('data-cart-line-key'), next);
        }
      }
    }
  });

  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-option-input]')) {
      var form = e.target.closest('[data-buy-box-form]');
      updateVariantSelection(form);
    }
  });

  function updateVariantSelection(form) {
    if (!form) return;
    var wrap = form.closest('[data-buy-box]');
    var productJsonEl = wrap.querySelector('[data-product-json]');
    if (!productJsonEl) return;
    var product;
    try { product = JSON.parse(productJsonEl.textContent); } catch (e) { return; }

    var selected = [];
    form.querySelectorAll('.buy-box__option').forEach(function (optionEl) {
      var checked = optionEl.querySelector('[data-option-input]:checked');
      selected.push(checked ? checked.value : null);
      optionEl.querySelectorAll('.buy-box__option-pill, .buy-box__swatch').forEach(function (pill) {
        var input = pill.querySelector('[data-option-input]');
        pill.classList.toggle('is-selected', !!(input && input.checked));
      });
      var currentLabel = optionEl.querySelector('[data-swatch-current]');
      if (currentLabel && checked) currentLabel.textContent = checked.value;
    });

    var match = product.variants.find(function (v) {
      var opts = [v.option1, v.option2, v.option3];
      return selected.every(function (val, i) { return val === null || opts[i] === val; });
    });
    if (!match) return;

    var hiddenId = form.querySelector('[data-variant-id]');
    if (hiddenId) hiddenId.value = match.id;
    // Keep the global tracker in sync so secondary CTAs pick up the currently-selected variant.
    window.__PDP_VARIANT_ID = match.id;
    var metaTracker = document.querySelector('[data-pdp-variant-id]');
    if (metaTracker) metaTracker.setAttribute('data-pdp-variant-id', match.id);

    var priceEl = wrap.querySelector('[data-price]');
    var compareEl = wrap.querySelector('[data-compare-price]');
    if (priceEl) priceEl.textContent = formatMoney(match.price);
    if (match.compare_at_price && match.compare_at_price > match.price) {
      if (compareEl) compareEl.textContent = formatMoney(match.compare_at_price);
    } else if (compareEl) {
      compareEl.textContent = '';
    }

    var addBtn = form.querySelector('[data-add-to-cart]');
    var addText = form.querySelector('[data-add-to-cart-text]');
    if (addBtn) addBtn.disabled = !match.available;
    if (addText) addText.textContent = match.available ? addText.getAttribute('data-label') || addText.textContent : 'Sold Out';

    if (match.featured_image) {
      var mainImg = document.querySelector('[data-gallery-main] img');
      if (mainImg) {
        var src = match.featured_image.src || '';
        if (src.indexOf('//') === 0) src = 'https:' + src;
        if (src) mainImg.src = src;
        if (match.featured_image.alt) mainImg.alt = match.featured_image.alt;
        // Also update any thumbnail that matches, and set it active
        var thumbs = document.querySelectorAll('[data-gallery-thumb]');
        thumbs.forEach(function (t) {
          var thumbFull = t.getAttribute('data-full') || '';
          var isMatch = thumbFull && src && thumbFull.split('?')[0].split('/').pop() === src.split('?')[0].split('/').pop();
          t.classList.toggle('is-active', isMatch);
        });
      }
    }
  }

  /* ---------------------------------------------------------------------
     Add to cart (AJAX) + cart drawer
  --------------------------------------------------------------------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-buy-box-form]');
    if (!form) return;
    e.preventDefault();
    var formData = new FormData(form);
    var submitBtn = form.querySelector('[data-add-to-cart]');
    if (submitBtn) submitBtn.disabled = true;

    fetch(window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: formData.get('id'), quantity: formData.get('quantity') || 1 })
    })
      .then(function (res) { return res.json(); })
      .then(function () {
        refreshCart(true);
      })
      .catch(function () {})
      .finally(function () {
        if (submitBtn) submitBtn.disabled = false;
      });
  });

  function cartUrl(path) {
    var root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
    return root.replace(/\/$/, '') + '/' + path.replace(/^\//, '');
  }

  function refreshCart(openDrawer) {
    fetch(cartUrl('/cart.js'))
      .then(function (res) { return res.json(); })
      .then(function (cart) { renderCart(cart); if (openDrawer) openCartDrawer(); })
      .catch(function () {});
  }

  function updateCartLine(key, quantity) {
    fetch(cartUrl('/cart/change.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) { renderCart(cart); })
      .catch(function () {});
  }

  function renderCart(cart) {
    var countEls = document.querySelectorAll('[data-cart-count]');
    countEls.forEach(function (el) { el.textContent = cart.item_count; });

    var itemsWrap = document.querySelector('[data-cart-items]');
    var emptyEl = document.querySelector('[data-cart-empty]');
    var template = document.getElementById('cart-line-item-template');
    if (!itemsWrap || !template) return;

    itemsWrap.querySelectorAll('.cart-drawer__line').forEach(function (el) { el.remove(); });

    if (cart.item_count === 0) {
      if (emptyEl) emptyEl.removeAttribute('hidden');
    } else {
      if (emptyEl) emptyEl.setAttribute('hidden', '');
      cart.items.forEach(function (item) {
        var node = template.content.cloneNode(true);
        var line = node.querySelector('.cart-drawer__line');
        line.setAttribute('data-cart-line-key', item.key);
        var img = node.querySelector('.cart-drawer__line-image img');
        var imageUrl = (item.featured_image && item.featured_image.url) || item.image || '';
        if (imageUrl) { img.src = imageUrl; img.alt = item.title; } else { img.remove(); }
        var titleLink = node.querySelector('.cart-drawer__line-title');
        titleLink.textContent = item.product_title;
        titleLink.href = item.url;
        var variantEl = node.querySelector('.cart-drawer__line-variant');
        variantEl.textContent = item.variant_title || '';
        node.querySelector('[data-qty-value]').textContent = item.quantity;
        node.querySelector('.cart-drawer__line-price').textContent = formatMoney(item.final_line_price);
        itemsWrap.appendChild(node);
      });
    }

    var subtotalEl = document.querySelector('[data-cart-subtotal]');
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

    var bar = document.querySelector('[data-shipping-bar]');
    if (bar) {
      var threshold = parseInt(bar.getAttribute('data-threshold'), 10) || 0;
      var remaining = Math.max(0, threshold - cart.total_price);
      var pct = threshold ? Math.min(100, (cart.total_price / threshold) * 100) : 100;
      var progress = bar.querySelector('[data-shipping-progress]');
      var msg = bar.querySelector('[data-shipping-message]');
      if (progress) progress.style.width = pct + '%';
      if (msg) {
        msg.textContent = remaining > 0
          ? 'Free Shipping On All US Orders 🎉'
          : 'Free Shipping On All US Orders 🎉';
      }
    }
  }

  document.addEventListener('click', function (e) {
    var removeBtn = e.target.closest('[data-line-remove]');
    if (removeBtn) {
      var line = removeBtn.closest('[data-cart-line-key]');
      if (line) updateCartLine(line.getAttribute('data-cart-line-key'), 0);
    }
  });

  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-cart-note]')) {
      fetch(cartUrl('/cart/update.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: e.target.value })
      });
    }
  });

  function openCartDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (drawer) { drawer.setAttribute('data-open', ''); drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
  }
  function closeCartDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (drawer) { drawer.removeAttribute('data-open'); drawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-toggle]')) {
      e.preventDefault();
      refreshCart(false);
      openCartDrawer();
    }
    if (e.target.closest('[data-cart-close]')) closeCartDrawer();
  });

  if (document.querySelector('[data-cart-drawer]')) {
    refreshCart(false);
  }

  /* ---------------------------------------------------------------------
     Scratch-to-win popup
  --------------------------------------------------------------------- */
  var scratchPopup = document.querySelector('[data-scratch-popup]');
  if (scratchPopup) {
    var alreadyShown = false;
    try { alreadyShown = sessionStorage.getItem('velora-scratch-shown') === '1'; } catch (e) {}

    if (!alreadyShown) {
      var delay = parseInt(scratchPopup.getAttribute('data-delay'), 10) || 8000;
      setTimeout(function () {
        scratchPopup.removeAttribute('hidden');
        try { sessionStorage.setItem('velora-scratch-shown', '1'); } catch (e) {}
        initScratchCanvas();
      }, delay);
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-scratch-close]')) {
        scratchPopup.setAttribute('hidden', '');
      }
    });

    function initScratchCanvas() {
      var canvas = scratchPopup.querySelector('[data-scratch-canvas]');
      if (!canvas || !canvas.getContext) return;
      var ctx = canvas.getContext('2d');

      function paintCover() {
        var w = canvas.width, h = canvas.height;
        var gradient = ctx.createLinearGradient(0, 0, w, h);
        gradient.addColorStop(0, '#cfd8e8');
        gradient.addColorStop(1, '#9aa9c4');
        ctx.fillStyle = gradient;
        ctx.fillRect(0, 0, w, h);
        ctx.fillStyle = 'rgba(255,255,255,.85)';
        ctx.font = '700 16px sans-serif';
        ctx.textAlign = 'center';
        ctx.fillText('SCRATCH HERE', w / 2, h / 2);
      }
      paintCover();
      ctx.globalCompositeOperation = 'destination-out';

      var scratching = false;
      function getPos(e) {
        var rect = canvas.getBoundingClientRect();
        var scaleX = canvas.width / rect.width;
        var scaleY = canvas.height / rect.height;
        var point = e.touches ? e.touches[0] : e;
        return { x: (point.clientX - rect.left) * scaleX, y: (point.clientY - rect.top) * scaleY };
      }
      function scratch(e) {
        var pos = getPos(e);
        ctx.beginPath();
        ctx.arc(pos.x, pos.y, 22, 0, Math.PI * 2);
        ctx.fill();
        checkRevealComplete();
      }
      function checkRevealComplete() {
        var data = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
        var cleared = 0, total = data.length / 4;
        for (var i = 3; i < data.length; i += 4 * 20) { if (data[i] === 0) cleared++; }
        if (cleared / (total / 20) > 0.5) {
          var intro = scratchPopup.querySelector('[data-scratch-intro]');
          var result = scratchPopup.querySelector('[data-scratch-result]');
          if (intro) intro.setAttribute('hidden', '');
          if (result) result.removeAttribute('hidden');
        }
      }
      canvas.addEventListener('mousedown', function () { scratching = true; });
      window.addEventListener('mouseup', function () { scratching = false; });
      canvas.addEventListener('mousemove', function (e) { if (scratching) scratch(e); });
      canvas.addEventListener('touchstart', function (e) { scratching = true; scratch(e); });
      canvas.addEventListener('touchmove', function (e) { if (scratching) { scratch(e); e.preventDefault(); } }, { passive: false });
      canvas.addEventListener('touchend', function () { scratching = false; });
    }
  }

  /* ---------------------------------------------------------------------
     PDP - unified add-to-cart for buttons outside the main buy box
     Any element with [data-pdp-add-to-cart] posts the primary variant.
  --------------------------------------------------------------------- */
  function getPrimaryVariantId() {
    // Always prefer the current form's hidden input — that's what the swatch/variant selector updates.
    var mainForm = document.querySelector('[data-buy-box-form]');
    if (mainForm) {
      var vinput = mainForm.querySelector('[data-variant-id]') || mainForm.querySelector('input[name="id"]');
      if (vinput && vinput.value) return vinput.value;
    }
    if (window.__PDP_VARIANT_ID) return window.__PDP_VARIANT_ID;
    var meta = document.querySelector('[data-pdp-variant-id]');
    if (meta) return meta.getAttribute('data-pdp-variant-id');
    return null;
  }

  function pdpOpenDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (drawer) {
      drawer.setAttribute('data-open', '');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    } else {
      window.location.href = '/cart';
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-pdp-add-to-cart]');
    if (!btn) return;
    e.preventDefault();
    var navUrl = btn.getAttribute('data-nav-url');
    if (navUrl) { window.location.href = navUrl; return; }
    var variantId = getPrimaryVariantId();
    if (!variantId) { window.location.href = '/collections/all'; return; }
    var qty = parseInt(btn.getAttribute('data-qty') || '1', 10) || 1;
    if (btn.disabled) return;
    btn.disabled = true;
    var originalHTML = btn.innerHTML;
    btn.innerHTML = '<span>Adding…</span>';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: qty }] })
    })
      .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
      .then(function (result) {
        if (result.ok) {
          btn.innerHTML = '<span>Added ✓</span>';
          // Update cart count if present
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            var count = document.querySelector('[data-cart-count]');
            if (count) count.textContent = cart.item_count;
            if (typeof refreshCart === 'function') refreshCart(false);
            pdpOpenDrawer();
          });
        } else {
          btn.innerHTML = '<span>' + (result.data && result.data.description || 'Try again') + '</span>';
        }
      })
      .catch(function () { btn.innerHTML = '<span>Error — try again</span>'; })
      .then(function () {
        setTimeout(function () { btn.innerHTML = originalHTML; btn.disabled = false; }, 1800);
      });
  });

  /* Update primary variant tracker whenever main variant selector changes */
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-variant-id]');
    if (input && input.value) window.__PDP_VARIANT_ID = input.value;
  });

  /* Sticky bottom CTA — reveal after user scrolls past the buy box */
  var sticky = document.querySelector('[data-pdp-sticky]');
  var mainCta = document.querySelector('.buy-box__cta');
  if (sticky && mainCta) {
    var showSticky = function () {
      var rect = mainCta.getBoundingClientRect();
      var below = rect.bottom < 0;
      var nearFooter = (window.innerHeight + window.scrollY) >= (document.body.offsetHeight - 260);
      if (below && !nearFooter) sticky.setAttribute('data-visible', '');
      else sticky.removeAttribute('data-visible');
    };
    window.addEventListener('scroll', showSticky, { passive: true });
    showSticky();
  }
})();
